/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Method_BankInputs */

const en_method_bank = /** @type {(inputs: Method_BankInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`bank`)
};

const he_method_bank = /** @type {(inputs: Method_BankInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`העברה בנקאית`)
};

/**
* | output |
* | --- |
* | "bank" |
*
* @param {Method_BankInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const method_bank = /** @type {((inputs?: Method_BankInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Method_BankInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_method_bank(inputs)
	return he_method_bank(inputs)
});